import { render, staticRenderFns } from "./navMessaging.vue?vue&type=template&id=fa593620&scoped=true"
import script from "./navMessaging.vue?vue&type=script&lang=js"
export * from "./navMessaging.vue?vue&type=script&lang=js"
import style0 from "./navMessaging.vue?vue&type=style&index=0&id=fa593620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa593620",
  null
  
)

export default component.exports